import { getFullJobDetails } from '../api/JobDetailsApi';

export const fullJobDetails = (data) => async (dispatch) => {
    if(data) {
        try {
            const result = await getFullJobDetails(data);
            if (result?.data) dispatch({ type: 'FULL_JOB_DETAILS', payload: result.data });
            else if (result?.error) {
                let notify = { msg: result.error, theme: 'error' };
                dispatch({ type: 'NOTIFICATION', payload: notify});
            }
        } catch (error) {
            return error;
        }
    }
    else
        dispatch({ type: 'FULL_JOB_DETAILS', payload: '' });
};
